<template>

  <div class="atividades-tabelaalterada ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="3">
                <label for="select-garagem">Garagem</label>  <!--selecionadas {{value_garagem.map(a => a.id_filial)}} -->

                <multiselect  v-model="value_garagem" required 
                  :options="garagens" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a garagem" label="garagem" track-by="garagem" name="garagem"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                   <label for="select-garagem">Modalidade</label> <!-- selecionadas {{value_modalidade.map(m => m.id_modalidade)}} -->
                <multiselect v-model="value_modalidade"  required
                :options="modalidades" 
                :multiple="true"                 
                :close-on-select="false" 
                :clear-on-select="true" 
                :preserve-search="true" placeholder="Modalidade" label="modalidade" track-by="modalidade" name="modalidade"
                :preselect-first="true">
                <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} modalidade selecionado</span></template>
                </multiselect>                
              </b-col>

              <b-col cols="3">
                   <label for="select-sptransx">Sptrans</label> <!--selecionadas {{value_sptrans.map(s => s.id_status)}} -->

                <multiselect v-model="value_sptrans"  required

                :options="sptransx"
                :multiple="true"
                :close-on-select="true" 
                :clear-on-select="false" 
                :preserve-search="true" placeholder="Status de envio" label="status" track-by="sptrans" name="sptrans"
                :preselect-first="true">
                <template id="sptrans" slot="selection" slot-scope="{ values,isOpen }"><span  v-if="values.length &amp;&amp; !isOpen">{{ values.length }} status selecionado</span></template>
                </multiselect>                
              </b-col>

              <!-- -->

              <b-col cols="2">
                   <div>                            
                        <label  for="datepicker-placeholder">Data escala</label> 
                        <b-form-datepicker id="datepicker-placeholder"  v-model="data_servico" required 
                          placeholder="Selecione uma data" 
                          initial-date
                          locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                    </div>                     
              </b-col>                   
                    
              <b-col>
                <br>                 
                <b-button size="sm" variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadTabelaAlteradas()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                </b-button>                      
              </b-col>
          </b-row>
    </b-form>

    <b-col>
      <div >                     
       
       <b-progress  :max="barra_limite">
        <b-progress-bar variant="success"  :value="barra_inicial" :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"></b-progress-bar>
      </b-progress>

      </div>
    </b-col>
    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="sptalteracoes"  small hover striped sticky-header="900px"  :items="tabelaalteradas" :fields="fields" >
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  :disabled="atualizando" @click="atualizando = true,loadCarregaTabela(data.item), putTabelaAlteradas(), loadTabelaAlteradas()"   title="Informar Sptrans"  size="sm" variant="primary" class="mr-2 mt-2">                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
      </b-table>
  </div>  
</template>


<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {    
    name: 'TrafegoTabelaAlterada',    

    data: function() {
      
        return {
            mode: 'save',
            carregando: false,
            atualizando: false,
            garagem:{}, 
            garagens: [],   // [] lista            
            value_garagem:[],// [] lista     
            
            sptrans:{},
            sptransx: [],   // [] lista            
            value_sptrans:[],// [] lista     

            modalidade:{},
            modalidades: [],   // [] lista            
            value_modalidade:[],// [] lista   
                                     
            tabelaalterada:{},// [] lista       

            tabelaalteradas:[],// [] lista       
            data_servico: '',

            barra_inicial: 0,         
            barra_limite: 300000,
            
            fields: [
                { key: 'id_alteracao', label: 'Id', sortable: true },     
                { key: 'id_garagem', label: 'Garagem', sortable: true }, 
                { key: 'data_alteracao', label: 'Data alteração', sortable: true, formatter: (value, key, tabelaalteradas) => {
                    return moment(tabelaalteradas.data_alteracao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'modalidade', label: 'Modalidade', sortable: true },                
                { key: 'linha', label: 'Linha', sortable: true },
                
                { key: 'hr_inicio_linha', label: 'Hora Linha', sortable: true },

                { key: 'prog_carro', label: 'Carro Programado', sortable: true },                
                { key: 'prog_motorista', label: 'Motorista Programado', sortable: true },                
                { key: 'prog_cobrador', label: 'Cobrador Programado', sortable: true },   
              
                { key: 'tabela', label: 'Tabela', sortable: true   },
                { key: 'alt_carro', label: 'Carro Alterado', sortable: true }, 
                { key: 'motorista_cpf', label: 'Motorista Alterado', sortable: true },
                { key: 'cobrador_cpf', label: 'Cobrador Alterado', sortable: true },
                
                { key: 'origem', label: 'Origem', sortable: true },
                { key: 'alterado_por', label: 'Alterado Por', sortable: true },                
                { key: 'sptrans', label: 'Status Sptrans', sortable: true },

                { key: 'dt_envio_sptrans', label: 'Data Sptrans', sortable: true, formatter: (value, key, tabelaalteradas) => {
                    return moment(tabelaalteradas.dt_envio_sptrans).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') ; }  },

                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {

      //barra de progresso
      ready () {
      this.handle = setInterval(() =>{
        this.barra_inicial = this.barra_inicial + 1000
        if(this.barra_inicial >= this.barra_limite){
          this.barra_inicial = 0
          this.loadTabelaAlteradas()
        }
      },1000)
      },

        loadGaragens() {
          const url = `${baseApiUrl}/trafego/garagem`
          axios.get(url).then(res => {
            this.garagens = res.data.map(garagem => {              
              return { id_filial: garagem.id_filial, garagem: garagem.garagem }
            })
          })
        },

        loadModalidade() {
          const url = `${baseApiUrl}/trafego/modalidade`
          axios.get(url).then(res => {
            this.modalidades = res.data.map(modalidade => {              
              return { id_modalidade: modalidade.id_modalidade, modalidade: modalidade.modalidade }
            })
          })
        },

        loadSptrans() {
          const url = `${baseApiUrl}/trafego/sptrans`
          axios.get(url).then(res => {
            this.sptransx = res.data.map(sptrans => {              
              return { id_status: sptrans.id_status, status: sptrans.status }
            })
          })
        },

        loadTabelaAlteradas() {            
            //const url = `${baseApiUrl}/trafego/tabelaalterada/${[this.value_garagem.map(a => a.id_filial)]},${this.value_modalidade.id_modalidade},${this.value_sptrans.id_status},${this.data_servico}`     
            
            let corpo = {    
                "id_garagem": `${[this.value_garagem.map(a => a.id_filial)]}`,
                "id_modalidade": `${[this.value_modalidade.map(m => m.id_modalidade)]}`,
                "id_status": `${[this.value_sptrans.map(s => s.id_status)]}`,                
                "data_servico": `${this.data_servico}`
            };
 
            const url = `${baseApiUrl}/trafego/tabelaalterada/`
            
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.tabelaalteradas = res.data.map(tabelaalterada => {
                            return {                              
                              id_alteracao: tabelaalterada.id_alteracao, 
                              id_garagem: tabelaalterada.id_garagem, 
                              data_alteracao: tabelaalterada.data_alteracao,
                              data_servico: tabelaalterada.data_servico, 
                              id_modalidade: tabelaalterada.id_modalidade,
                              modalidade: tabelaalterada.modalidade,
                              linha: tabelaalterada.linha,
                              periodo: tabelaalterada.periodo, 
                              tabela: tabelaalterada.tabela,
                              loc_ini_linha: tabelaalterada.loc_ini_linha,
                              hr_inicio_linha: tabelaalterada.hr_inicio_linha, 
                              prog_carro: tabelaalterada.prog_carro, 
                              prog_motorista: tabelaalterada.prog_motorista, 
                              prog_cobrador: tabelaalterada.prog_cobrador, 
                              alt_carro: tabelaalterada.alt_carro,    
                              motorista_cpf: tabelaalterada.motorista_cpf,
                              cobrador_cpf: tabelaalterada.cobrador_cpf,
                              origem: tabelaalterada.origem,
                              alterado_por: tabelaalterada.alterado_por,
                              id_status: tabelaalterada.id_status,
                              sptrans : tabelaalterada.sptrans,
                              dt_envio_sptrans: tabelaalterada.dt_envio_sptrans,
                              id_funcionario_enviado_sptrans: tabelaalterada.id_funcionario_enviado_sptrans
                            }              
                                                })
                        })            
        }, 
        loadCarregaTabela(tabelaalterada){
            this.tabelaalterada = { ...tabelaalterada }
        }, 

        putTabelaAlteradas() {                        
            const url = `${baseApiUrl}/trafego/sptrans/alterada/${this.tabelaalterada.id_alteracao}`     
            axios.put(url).then(res => {                                
                this.carregando = false
                this.atualizando = false
                this.tabelaalterada = res.data                
            })            
        },          
    },

    mounted() {        
        this.loadGaragens()  
        this.loadSptrans()      
        this.loadModalidade()
        this.loadTabelaAlteradas()
        this.putTabelaAlteradas()
        this.loadCarregaTabela()   
        this.ready() 
       // destroyed()              
    },

}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.table{
    font-size: 0.8em;      
    text-align: center; 
    
}

</style>